/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import get from 'lodash/get';
import { gnoment } from 'shared-ui/gnoment';

import {
    ISSUANCE_STATUS,
    LOTTERY_ACCEPTED,
    LOTTERY_AWARDED,
    SINGLE_DATE_PICKER_TYPE,
    RANGE_DATE_PICKER_TYPE,
} from './constants';
import { getCurrentTime } from './permit-utilsNew';
import { isZeroOrUnitialized } from './date_time_utils_new';

export function getDatePickerType(item) {
    return isZeroOrUnitialized(item?.preferred_range_start)
        ? SINGLE_DATE_PICKER_TYPE
        : RANGE_DATE_PICKER_TYPE;
}

export const filterAndSortQueuingLotteries = (lotteries, filterStatus) => {
    return lotteries
        .filter(({ status }) => status === filterStatus)
        .sort((a, b) => (get(a, 'start_date') > get(b, 'start_date') ? 1 : -1));
};

export const filterAndSortLotteries = (lotteries, filterStatus) => {
    return lotteries
        .filter(({ status }) => status === filterStatus)
        .sort((a, b) => (get(a, 'start_date') > get(b, 'start_date') ? 1 : -1));
};

const sortLotteriesBy = (lotteries, fieldPath) => {
    return lotteries.sort((a, b) => (get(a, fieldPath) > get(b, fieldPath) ? 1 : -1));
};

export const mapAndSortLotteries = ({
    lotteries,
    permitTimeZone,
    isOldLotteryFormat = false,
}) => {
    const timeZoneToUse = permitTimeZone || 'America/Los_Angeles';
    const lotteriesMap = lotteries.reduce(
        ({ openLotteries, futureLotteries }, lotteryObject) => {
            const { open_at, close_at, display_at } = lotteryObject?.lottery;
            const displayAt = isOldLotteryFormat
                ? gnoment(display_at).tz(timeZoneToUse)
                : gnoment.unix(display_at.seconds).tz(timeZoneToUse);
            const openTime = isOldLotteryFormat
                ? gnoment(open_at).tz(timeZoneToUse)
                : gnoment.unix(open_at.seconds).tz(timeZoneToUse);
            const closeTime = isOldLotteryFormat
                ? gnoment(close_at).tz(timeZoneToUse)
                : gnoment.unix(close_at.seconds).tz(timeZoneToUse);
            const isInFuture =
                gnoment().isAfter(displayAt) && gnoment().isBefore(openTime);
            const isOpen = gnoment().isAfter(openTime) && gnoment().isBefore(closeTime);
            if (isInFuture) {
                futureLotteries.push(lotteryObject);
            } else if (isOpen) {
                openLotteries.push(lotteryObject);
            }
            return {
                openLotteries,
                futureLotteries,
            };
        },
        {
            openLotteries: [],
            futureLotteries: [],
        }
    );
    return {
        openLotteries: sortLotteriesBy(lotteriesMap.openLotteries, 'start_date'),
        futureLotteries: sortLotteriesBy(lotteriesMap.futureLotteries, 'start_date'),
    };
};

export const filterAndSortOpenLotteries = ({
    lotteries,
    permitTimeZone,
    isOldLotteryFormat = false,
}) => {
    const timeZoneToUse = permitTimeZone || 'America/Los_Angeles';
    return sortLotteriesBy(
        lotteries.filter((lotteryObject) => {
            const { open_at, close_at } = lotteryObject?.lottery;
            const openTime = isOldLotteryFormat
                ? gnoment(open_at).tz(timeZoneToUse)
                : gnoment.unix(open_at.seconds).tz(timeZoneToUse);
            const closeTime = isOldLotteryFormat
                ? gnoment(close_at).tz(timeZoneToUse)
                : gnoment.unix(close_at.seconds).tz(timeZoneToUse);
            const isInFuture = gnoment().isBefore(openTime);
            const isOpen = gnoment().isBefore(closeTime);
            return !isInFuture && isOpen;
        }),
        'start_date'
    );
};

export const isInvalidLotteryAward = ({ permit, lottery, issuance, currentDate }) => {
    const incorrectStatus =
        issuance.status !== ISSUANCE_STATUS.get(LOTTERY_AWARDED) ||
        issuance.status === ISSUANCE_STATUS.get(LOTTERY_ACCEPTED);
    if (incorrectStatus) {
        return true;
    }
    const currentTime = getCurrentTime({ currentDate });
    const announcedTimestamp = get(lottery, 'lottery.announced_at', false);
    if (
        announcedTimestamp &&
        gnoment(announcedTimestamp).tz(permit.time_zone).isAfter(currentTime)
    ) {
        return true;
    }
    return false;
};

export function isAwardedLottery(issuance) {
    return (
        issuance.status === ISSUANCE_STATUS.get(LOTTERY_AWARDED) &&
        !!get(issuance, 'lottery_awarded')
    );
}

export function isAwardedLotteryApplicationPendingAnswer(issuance) {
    return isAwardedLottery(issuance) && !get(issuance, 'lottery_accepted');
}
